import * as Yup from "yup";

export const validationSchema = Yup.object().shape({
  app_id: Yup.string().required("App ID is required"),
  firebase_service_account_json: Yup.object().required(
    "Firebase service account is required"
  ),
  name: Yup.string().required("Name is required"),
  api_key: Yup.string().required("API key is required"),
  database_url: Yup.string().required("Database URL is required"),
  game_servers: Yup.array().required("Game servers are required"),
  deeplink_open_app: Yup.string().required("Deeplink open app is required"),
  is_secure: Yup.bool(),
  host: Yup.string().required("Host is required"),
  port: Yup.string().required("Port is required"),
  storage_bucket: Yup.string().required("Storage bucket is required"),
  config_versions: Yup.array()
    .of(
      Yup.object().shape({
        key: Yup.string().required("Version is required"),
        value: Yup.number().required("Value is required"),
      })
    )
    .required("Config versions are required"),
});

// TODO: Should be temporary due to wrong structure on the backend at the moment
export const normalizeGameObject = ({
  id,
  name,
  apiKey,
  firebaseServiceAccountJson,
  appId,
  databaseUrl,
  gameServers,
  deeplinkOpenApp,
  isSecure,
  host,
  port,
  storageBucket,
  configVersions,
  logo,
  imagePreview,
}) => ({
  id: id,
  name: name,
  api_key: apiKey,
  firebase_service_account_json: JSON.stringify(firebaseServiceAccountJson),
  app_id: appId,
  database_url: databaseUrl,
  game_servers: JSON.stringify(gameServers),
  deeplink_open_app: deeplinkOpenApp,
  is_secure: isSecure,
  host: host,
  port: port,
  storage_bucket: storageBucket,
  config_versions:
    configVersions &&
    Object.entries(configVersions).map(([key, value]) => ({
      key,
      value,
    })),
  logo: logo,
  imagePreview: imagePreview,
});
